import { usePrivy, useWallets } from '@privy-io/react-auth'
export function useEmbeddedWallet() {
    const { ready: privyReady, authenticated } = usePrivy()
    const { wallets, ready: walletsReady } = useWallets()

    const embeddedWallet = wallets.find((wallet) => wallet.walletClientType === 'privy')

    return {
        embeddedWallet,
        privyReady,
        walletsReady,
        privyAuthenticated: authenticated,
    }
}
